<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M4 7.74797V23C4 24.6569 5.34315 26 7 26H25C26.6569 26 28 24.6569 28 23V12.252C28 10.5952 26.6569 9.25203 25 9.25203H5.62602C4.72799 9.25203 4 8.52404 4 7.62602V7.62602C4 6.72799 4.72799 6 5.62602 6H19.7604C21.4173 6 22.7604 7.34315 22.7604 9V9.15549"
        stroke="var(--icon-color)" stroke-width="2" />
    <path
        d="M27.5 15.1158H22.8918C21.5363 15.1158 20.4375 16.2147 20.4375 17.5701V17.5701C20.4375 18.9256 21.5363 20.0244 22.8918 20.0244H27.5"
        stroke="var(--icon-color)" stroke-width="2" />
    <path d="M13 26L13 17" stroke="var(--icon-color)" stroke-width="1.5" />
    <path d="M9.80366 20.1963L13 17L16.1605 20.1605" stroke="var(--icon-color)" stroke-width="1.5" />
</svg>

